import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Scholarship.css';
import { useTranslation } from 'react-i18next';

export default function ScholarshipCard({ data, id }) {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 100 });
  }, []);

  // Determine background color based on id
  const bgColor = id === 'scholarship-1' || id === 'scholarship-3'
    ? 'bg-gray-100'
    : 'bg-sky-100';

  const handleApplyClick = (e) => {
    e.preventDefault();
    if (id === 'scholarship-1') {
      window.open('https://forms.gle/RhNE44W16NJaXUAY6', '_blank');
    } else if (id === 'scholarship-2') {
      window.open('https://forms.gle/SY2t1KCMLDPKJcC1A', '_blank');
    }
  };

  const handleScholarshipPDFClick = (e) => {
    e.preventDefault();
    window.open('https://drive.google.com/file/d/1aJ5c77YJLBMS389OxZ2eV9XSJJc_dvWf/view?usp=drivesdk', '_blank'); // Update with the actual path
  };

  return (
    <div id={id} className={`flex flex-col lg:flex-row justify-center items-center p-2 lg:p-8 ${bgColor}`}>
      <div data-aos="zoom-in-right" className="flex items-center justify-center p-2 lg:p-8">
        <img
          className="w-24 h-24 lg:w-60 lg:h-60"
          src={data.logo}
          alt="Logo"
        />
      </div>
      <div data-aos="zoom-in-left" className="w-full p-2 lg:w-2/3 lg:p-8">
        <div className="px-5 mb-4 text-xl font-bold text-center text-red-600 lg:text-2xl">{t(data.title)}</div>
        <div className="h-64 p-4 overflow-y-auto lg:p-0 lg:h-80 scrollbar" style={{ backgroundColor: 'inherit' }}>
          <div className="px-5 text-justify text-gray-700 text-xs sm:text-sm lg:text-base" dangerouslySetInnerHTML={{ __html: t(data.content) }} />
        </div>
        {data.stats && (
          <div
            className={`grid grid-cols-2 gap-2 mt-4 lg:gap-4 lg:mt-8 ${id === 'scholarship-1' ? 'lg:grid-cols-4' : 'lg:grid-cols-5'
              }`}
          >
            {data.stats.map((stat, index) => (
              <div key={index} className="flex flex-col items-center text-center">
                <div className="text-lg font-bold text-blue-600 sm:text-xl lg:text-2xl">{t(stat.number)}</div>
                <div className="text-xs text-gray-800 sm:text-sm lg:text-base">{t(stat.label)}</div>
              </div>
            ))}
            {id === 'scholarship-1' && (
              <div className="flex flex-col sm:flex-row justify-center items-center w-full mt-2 col-span-2 lg:col-span-2 lg:mt-0">
                <button
                  className="px-3 py-2 text-xs text-white bg-red-600 rounded-md sm:text-sm lg:text-base mb-2 sm:mb-0 sm:mr-2"
                  onClick={handleApplyClick}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {t('Apply1')}
                </button>
               <div className="relative inline-block">
  <button
    className="px-3 py-2 text-xs text-white bg-blue-600 rounded-md sm:text-sm lg:text-base"
    onClick={handleScholarshipPDFClick}
    style={{ whiteSpace: 'nowrap' }}
  >
    {t('Scholar')}
  </button>

  {/* "New" Badge */}
  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] font-semibold px-1.5 py-0.5 rounded-full">
    New
  </span>
</div>

              
              </div>
            )}
            {id === 'scholarship-2' && (
              <div className="flex justify-center items-center w-full mt-2 col-span-2 lg:col-span-1 lg:mt-0">
                <button
                  className="px-3 py-2 text-xs text-white bg-red-600 rounded-md sm:text-sm lg:text-base"
                  onClick={handleApplyClick}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {t('Apply2')}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
